import { Component, OnInit, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { CustomValidators } from '../../../helpers/custom-validators';

@Component({
  selector: 'ct-control-messages',
  templateUrl: './control-messages.component.html',
  styleUrls: ['./control-messages.component.scss']
})
export class ControlMessagesComponent implements OnInit {

  @Input() control: FormControl;

  constructor() { }

  ngOnInit(): void {
  }

  get errorMessage() {
    for (const propertyName in this.control.errors) {
      if (this.control.errors.hasOwnProperty(propertyName) && this.control.invalid && (this.control.dirty || this.control.touched)) {
        return CustomValidators.getValidatorErrorMessage(propertyName, this.control.errors[propertyName]);
      }
    }

    return null;
  }

}
